module.exports = __webpack_public_path__ + "img/1169.0d803c60.gif";